export default __webpack_public_path__ + "static/media/macbook-pro.14dec0bc.png";